// This file was generated by the Zuplo CLI migrate-dev-portal command.
// It is used to configure the Zuplo dev portal.
// You can edit this file to customize the dev portal.
// For more information, see https://zuplo.com/docs/dev-portal/zudoku/configuration/overview
import type { ZudokuConfig } from "zudoku";
import { BalanceDisplay } from "./pages/components/BalanceDisplay";

const config: ZudokuConfig = {
  apiKeys: {
    enabled: true,
  },
  site: {
    title: "code.to.design API - HTML to Figma",
    logo: {
      src: {
        light:
          "https://cdn.divriots.com/c2d/logo-v1.svg",
        dark: "https://cdn.divriots.com/c2d/logo-v1.svg",
      },
      alt: "code.to.design logo",
      href: "https://code.to.design",
    },
  },
  slots: {
    'head-navigation-start': () => (
      <span style={{ fontSize: '1.5rem', fontWeight: 600 }}>Portal</span>
    ),
  },
  metadata: {
    title: "code.to.design API - HTML to Figma",
    favicon: "https://cdn.divriots.com/c2d/favicon-v1.png"
  },
  navigation: [
    {
      type: "doc",
      file: "overview",
      label: "Overview",
    },
    {
      type: "doc",
      file: "clipboard-mode",
      label: "Clipboard mode",
    },
    {
      type: "doc",
      file: "plugin-mode",
      label: "Plugin mode",
    },
    {
      type: "doc",
      file: "pricing",
      label: "Pricing",
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
    {
      type: "link",
      to: "/settings/api-keys",
      label: "API Keys",
    },
    {
      type: "doc",
      file: "support",
      label: "Support",
    },    
    {
      type: "doc",
      file: "more-apis",
      label: "More APIs",
    },    
  ],
  apis: [
    {
      type: "file",
      input: "../config/routes.oas.json",
      path: "/api",
    },
  ],
  redirects: [{ from: "/", to: "/overview" }],
  authentication: {
    type: "auth0",
    clientId: "Hj7WDNo49ReULAUPGvCvBNC1jivDGenQ",
    domain: "code-to-design.eu.auth0.com",
    audience: "https://api.to.design/",
  },
  slots: {
    "head-navigation-end": <BalanceDisplay />,
  },
};
export default config;
